import React from 'react';
import Button from '../ui/Button';
import { profile } from '../../data/content';
import './Hero.css';

const FLOATING_CHIPS = [
  { label: 'Python', className: 'hero__chip--1' },
  { label: 'React', className: 'hero__chip--2' },
  { label: 'Machine Learning', className: 'hero__chip--3' },
  { label: 'AWS', className: 'hero__chip--4' },
  { label: 'Computer Vision', className: 'hero__chip--5' },
];

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__content">
        <span className="hero__eyebrow">~/portfolio $ whoami</span>
        <h1 className="hero__title">
          {profile.firstName}{' '}
          <span className="gradient-text">{profile.lastName}</span>
        </h1>
        <p className="hero__role">{profile.role}</p>
        <p className="hero__tagline">{profile.tagline}</p>
        <div className="hero__cta">
          <Button variant="primary" href="#projects">
            View My Work
          </Button>
          <Button variant="ghost" href={`mailto:${profile.email}`}>
            Get In Touch
          </Button>
          <Button variant="subtle" href="/tokenizer">
            Tokenizer Tool
          </Button>
        </div>
      </div>

      <div className="hero__visual" aria-hidden="true">
        <div className="hero__orb">
          <div className="hero__orb-ring" />
          <div className="hero__orb-core" />
        </div>
        {FLOATING_CHIPS.map((chip) => (
          <span key={chip.label} className={`hero__chip ${chip.className}`}>
            {chip.label}
          </span>
        ))}
      </div>

      <a href="#about" className="hero__scroll-hint" aria-label="Scroll to about section">
        <span className="hero__scroll-mouse" />
      </a>
    </section>
  );
}
